module.exports = __webpack_public_path__ + "7ad3fdf095fae66007c1d8da715fda0b.svg";